import { IconDefinition, faXmark } from '@fortawesome/free-solid-svg-icons';

import { Component, OnInit } from '@angular/core';

import { NotificationService } from '@core/services';

import { NotificationItem } from '@shared/models';

@Component({
    selector: 'app-notification-list',
    templateUrl: './notification-list.component.html',
    styleUrls: ['./notification-list.component.scss'],
    standalone: false,
})
export class NotificationListComponent implements OnInit {
    public faXmark: IconDefinition = faXmark;
    public notifications: NotificationItem[] = [];

    constructor(private notificationService: NotificationService) {}

    ngOnInit(): void {
        this.notificationService.notifications.subscribe({
            next: (value: NotificationItem[]) => {
                this.notifications = value;
            },
            error: (err) => {
                console.error(`Something went wrong while fetching notifications ${err}`);
                this.notifications = [new NotificationItem('error', 'Something went wrong while fetching notifications')];
            },
        });
    }

    deleteNotification(index: number) {
        this.notificationService.removeNotification(index);
    }

    clearNotifications() {
        this.notificationService.clearAllNotifications();
    }

    trackNotification(index: number, _item: NotificationItem): number {
        return index;
    }
}
